module.exports = __webpack_public_path__ + "img/corner-right-up.4df81bc0.svg";